import { useEffect, useState } from 'react'

import { Breadcrumbs } from '../../../Breadcrumbs'

import { BREADCRUMBS_RELOAD_INTERVAL } from './BreadcrumbsCollapsed.constants'

function BreadcrumbsCollapsed() {
  const [reloadCount, setReloadCount] = useState(0)

  useEffect(() => {
    const intervalId = setInterval(() => {
      setReloadCount(count => count + 1)
    }, BREADCRUMBS_RELOAD_INTERVAL)

    return () => {
      clearInterval(intervalId)
    }
  }, [])

  // New item identities on every tick, like a list reload rebuilding the trail
  // from the response: the collapsed "..." dropdown must stay open and clickable.
  const items = [
    {
      id: 10,
      title: 'Home',
      onClick: () => console.log('Home', reloadCount),
    },
    {
      id: 11,
      title: 'Folder level one',
      onClick: () => console.log('Folder level one', reloadCount),
    },
    {
      id: 12,
      title: 'Folder level two',
      onClick: () => console.log('Folder level two', reloadCount),
    },
    {
      id: 13,
      title: 'Folder level three',
      onClick: () => console.log('Folder level three', reloadCount),
    },
    { id: 14, title: 'Current folder with a long name' },
  ]

  return (
    <div style={{ width: '40%' }}>
      <Breadcrumbs count={42} items={items} />
    </div>
  )
}

export default BreadcrumbsCollapsed
